function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.447 17.6c0 .726-.54 1.326-1.23 1.394l-.131.006h-1.362c-.707 0-1.29-.556-1.356-1.266l-.006-.134v-3.4a.695.695 0 0 0-.58-.693l-.101-.008h-1.362a.688.688 0 0 0-.674.597l-.007.103v3.4c0 .727-.541 1.327-1.23 1.395L9.275 19H7.914c-.706 0-1.29-.556-1.355-1.266l-.007-.134v-4.876a1 1 0 0 1-1.11-.068l-.093-.08-.05-.05-.017-.017a1 1 0 0 1-.068-1.32l.084-.094 5.977-5.838a.996.996 0 0 1 .64-.283h.17a.996.996 0 0 1 .64.283l5.977 5.838a1 1 0 0 1 0 1.431l-.05.05a1 1 0 0 1-1.204.148V17.6z",
  fill: "#FFF",
  fillRule: "evenodd"
});

function SvgIco24GnbHomeS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco24GnbHomeS);
export default __webpack_public_path__ + "static/media/ico_24_gnb_home_s.7d9594b0.svg";
export { ForwardRef as ReactComponent };